class MegaskaCollection {
  constructor() {
    this.section = document.querySelector('.mk-collection');
    if (!this.section) return;

    this.body = document.body;
    this.desktopFilterForm = this.section.querySelector('#MegaskaCollectionFiltersDesktop');
    this.desktopSortSelect = this.section.querySelector('#MegaskaSortByDesktop');
    this.mobileSortForm = this.section.querySelector('#MegaskaCollectionSortMobile');

    this.seoBlock = this.section.querySelector('[data-collection-seo-top]');
    this.seoToggle = this.section.querySelector('[data-seo-toggle]');
    this.activeDrawerType = null;

    this.bindEvents();
    this.initSeoBlock();
  }

  bindEvents() {
    this.section.addEventListener('click', (event) => {
      const openFiltersButton = event.target.closest('[data-open-filters]');
      if (openFiltersButton) {
        event.preventDefault();
        this.openDrawer('filters');
        return;
      }

      const openSortButton = event.target.closest('[data-open-sort]');
      if (openSortButton) {
        event.preventDefault();
        this.openDrawer('sort');
        return;
      }

      const closeButton = event.target.closest('[data-close-drawer]');
      if (closeButton) {
        event.preventDefault();
        this.closeAllDrawers();
      }
    });

    this.section.addEventListener('change', (event) => {
      if (!this.desktopFilterForm) return;

      const filterInput = event.target.closest(
        '#MegaskaCollectionFiltersDesktop input[type="checkbox"], #MegaskaCollectionFiltersDesktop input[type="radio"]'
      );

      if (filterInput) {
        this.desktopFilterForm.submit();
      }
    });

    if (this.desktopSortSelect) {
      this.desktopSortSelect.addEventListener('change', (event) => {
        const value = event.target.value;
        this.applySort(value);
      });
    }

    if (this.mobileSortForm) {
      this.mobileSortForm.addEventListener('submit', (event) => {
        event.preventDefault();
        const checkedInput = this.mobileSortForm.querySelector('input[name="sort_by"]:checked');
        const value = checkedInput ? checkedInput.value : '';

        if (!value) return;

        this.applySort(value);
      });
    }

    if (this.seoToggle && this.seoBlock) {
      this.seoToggle.addEventListener('click', () => {
        const isExpanded = this.seoToggle.getAttribute('aria-expanded') === 'true';
        this.seoToggle.setAttribute('aria-expanded', String(!isExpanded));
        this.seoBlock.setAttribute('data-collapsed', String(isExpanded));
        this.seoToggle.textContent = isExpanded ? 'Read more' : 'Read less';
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.activeDrawerType) {
        this.closeAllDrawers();
      }
    });
  }

  initSeoBlock() {
    if (!this.seoBlock || !this.seoToggle) return;

    const seoInner = this.seoBlock.querySelector('[data-seo-preview]');
    if (!seoInner) return;

    this.seoBlock.setAttribute('data-collapsed', 'true');
    this.seoToggle.setAttribute('aria-expanded', 'false');
    this.seoToggle.textContent = 'Read more';

    requestAnimationFrame(() => {
      const isOverflowing = seoInner.scrollHeight > seoInner.clientHeight + 4;

      if (!isOverflowing && seoInner.textContent.trim().length < 180) {
        this.seoToggle.hidden = true;
      }
    });
  }

  getDrawerElements(type) {
    const drawers = this.section.querySelectorAll(`[data-collection-drawer="${type}"]`);
    const buttons = this.section.querySelectorAll(
      type === 'filters' ? '[data-open-filters]' : '[data-open-sort]'
    );

    return { drawers, buttons };
  }

  openDrawer(type) {
    this.closeAllDrawers();

    const { drawers, buttons } = this.getDrawerElements(type);

    drawers.forEach((drawer) => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    });

    buttons.forEach((button) => {
      button.setAttribute('aria-expanded', 'true');
    });

    this.activeDrawerType = type;
    this.body.classList.add('mk-drawer-open');
  }

  closeDrawer(type) {
    const { drawers, buttons } = this.getDrawerElements(type);

    drawers.forEach((drawer) => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    });

    buttons.forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  closeAllDrawers() {
    this.closeDrawer('filters');
    this.closeDrawer('sort');
    this.activeDrawerType = null;
    this.body.classList.remove('mk-drawer-open');
  }

  applySort(value) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    window.location.href = url.toString();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new MegaskaCollection();
});
